import { InternalError } from './parsers/error';


export default function parseUrl(url) {
  // possible formats:
  // https://vimeo.com/148520418
  // https://vimeo.com/channels/staffpicks/149008769
  // https://vimeo.com/ondemand/almostthere

  if (!/vimeo\.com/.test(url)) {
    return Promise.reject(new InternalError(400, 'wpm_error.malformed_external_link', 'External link was not formatted properly'));
  }

  return Promise.resolve(url);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vimeo/parse-url.js